<template>
    <div>
        <div class="page-loader-wrapper" v-if="isButtonLoading">
            <div class="loader">
                <div>
                <img src="@/assets/images/Angel_Communities_Logo.svg" width="200" height="45" alt="PayAngel" />
                <p>Please wait...</p>
                </div>
            </div>
        </div>
        <div class="auth-main">
            <AuthLeftSideComponent/>
            <div class="auth-right">
                <div class="right-main d-flex flex-column h-100">
                    <!-- auth header -->
                    <RightHeaderComponent/>

                    <!-- dynamic content section -->
                    <slot></slot>
                    
                    <!-- right footer -->
                    <RightFooterComponent/>
                </div>
            </div> 
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import AuthLeftSideComponent from '@/components/layouts/auth/AuthLeftSideComponent.vue'
import RightHeaderComponent from '@/components/layouts/auth/RightHeaderComponent.vue'
import RightFooterComponent from '@/components/layouts/auth/RightFooterComponent.vue'
export default {
    name:'AuthLayout',
    components: {
        AuthLeftSideComponent,
        RightHeaderComponent,
        RightFooterComponent
    },methods:{
    },
    computed: {
        ...mapGetters(["isButtonLoading"]),
    },
}
</script>
<style scoped>
</style>